import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

// 푸터 컴포넌트 - 모든 페이지에서 공통으로 사용
function Footer() {
  const { isAdmin, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <footer className="site-footer">
      <div className="footer-content">
        {/* 왼쪽 섹션 */}
        <div className="footer-section">
          <p>© 2021 <strong style={{ color: '#fff' }}>Real-Time Ubiquitous System Laboratory</strong></p>
          <p>1 Gwanak-ro, Gwanak-gu, Seoul 08826 Republic of Korea</p>
          <p>301 Building 415, +82 2-880-2562</p>
        </div>

        {/* 오른쪽 섹션 */}
        <div className="footer-section">
          <p>
            <a href="http://cse.snu.ac.kr/" target="_blank" rel="noopener noreferrer">
              Department of Computer Science and Engineering
            </a>
          </p>
          <p>
            <a href="http://www.snu.ac.kr/" target="_blank" rel="noopener noreferrer">
              Seoul National University
            </a>
          </p>

          {/* Admin Login/Logout - p 태그로 완전히 통일 */}
          {!isAdmin ? (
            <p>
              <Link
                to="/login"
                style={{
                  color: '#999',
                  textDecoration: 'none'
                }}
                onMouseOver={(e) => e.target.style.color = '#fff'}
                onMouseOut={(e) => e.target.style.color = '#999'}
              >
                Admin Login
              </Link>
            </p>
          ) : (
            <p>
              <span style={{ color: '#999' }}>Admin</span>
              <span style={{ color: '#666', margin: '0 5px' }}>|</span>
              <button
                onClick={handleLogout}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#999',
                  cursor: 'pointer',
                  padding: 0,
                  textDecoration: 'underline',
                  font: 'inherit'
                }}
                onMouseOver={(e) => e.target.style.color = '#fff'}
                onMouseOut={(e) => e.target.style.color = '#999'}
              >
                Logout
              </button>
            </p>
          )}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
